import type { PermissionStatus } from "@capacitor/push-notifications";
import type { UseQueryResult } from "@tanstack/react-query";

export function canPromptForPushNotificationsPermissions(
	input: UseQueryResult<PermissionStatus>,
) {
	return (
		input.data?.receive === "prompt" ||
		input.data?.receive === "prompt-with-rationale"
	);
}
